import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(amount) {
  try {
    const num = typeof amount === 'number' ? amount : parseFloat(amount);
    if (isNaN(num) || !isFinite(num)) return '$0.00';
    return new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: 'MXN'
    }).format(num);
  } catch (e) {
    // Fallback for browsers without Intl support
    try {
      const num = typeof amount === 'number' ? amount : parseFloat(amount);
      if (isNaN(num)) return '$0.00';
      return '$' + num.toFixed(2);
    } catch (e2) {
      return '$0.00';
    }
  }
}

/**
 * Format a date string converting from UTC to local device time.
 */
export function formatDate(dateStr) {
  if (!dateStr) return '';
  
  // Parse as UTC and convert to local time using Date object
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return '';
  
  const day = date.getDate();
  const month = date.getMonth();
  const year = date.getFullYear();
  const hour = date.getHours();
  const minute = date.getMinutes();
  
  // Format the date
  const months = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 
                  'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
  const formattedDate = `${day} de ${months[month]} de ${year}`;
  
  // Format the time in 12-hour format
  const hour12 = hour % 12 || 12;
  const ampm = hour >= 12 ? 'p.m.' : 'a.m.';
  const formattedTime = `${String(hour12).padStart(2, '0')}:${String(minute).padStart(2, '0')} ${ampm}`;
  
  return `${formattedDate}, ${formattedTime}`;
}

/**
 * Format a date string to short format (DD/MM/YYYY, HH:MM a.m./p.m.)
 * Converts from UTC to local device time.
 */
export function formatDateShort(dateStr) {
  if (!dateStr) return '';
  
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return '';
  
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  const hour = date.getHours();
  const minute = date.getMinutes();
  
  const formattedDate = `${String(day).padStart(2, '0')}/${String(month).padStart(2, '0')}/${year}`;
  const hour12 = hour % 12 || 12;
  const ampm = hour >= 12 ? 'p.m.' : 'a.m.';
  const formattedTime = `${String(hour12).padStart(2, '0')}:${String(minute).padStart(2, '0')} ${ampm}`;
  
  return `${formattedDate}, ${formattedTime}`;
}

/**
 * Format date only (without time)
 * Converts from UTC to local device time.
 */
export function formatDateOnly(dateStr) {
  if (!dateStr) return '';
  
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return '';
  
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  
  return `${String(day).padStart(2, '0')}/${String(month).padStart(2, '0')}/${year}`;
}

/**
 * Open WhatsApp — works with regular WhatsApp AND WhatsApp Business.
 * Uses whatsapp:// scheme which the OS routes to whichever is installed.
 */
export function openWhatsApp(phone, message) {
  const encoded = encodeURIComponent(message);
  let num = phone ? phone.replace(/\D/g, '') : '';
  if (num && num.length === 10) num = '52' + num;

  const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

  if (isMobile) {
    const url = num
      ? `whatsapp://send?phone=${num}&text=${encoded}`
      : `whatsapp://send?text=${encoded}`;
    window.location.href = url;
  } else {
    const url = num
      ? `https://wa.me/${num}?text=${encoded}`
      : `https://wa.me/?text=${encoded}`;
    window.location.href = url;
  }
}
